export default __webpack_public_path__ + "static/media/placeholder8.da7a0a9b.png";